import { Box, Flex } from '@radix-ui/themes'
import { Link } from 'react-router';

export function Logo() {
  return (
    <Link to="/">
      <Flex
        gap="2"
        className="text-sm transition duration-300 hover:-translate-x-1 hover:text-primary 3xl:text-base"
      >
        <Box className="font-bold">DEx</Box>
        <Box className="hidden font-light lg:block">Design Explorer</Box>
      </Flex>
    </Link>
  )
}
